import { IApplicantFormService } from "../../service/form/ApplicantFormService";

export default class UpdateAdditionalEvaluationResultInteractor {
  private applicantFormService: IApplicantFormService;

  constructor(applicantFormService) {
    this.applicantFormService = applicantFormService;
  }

  async execute(
    reportingPeriodApplicantId: number,
    additionalEvaluationResult: string
  ) {
    await this.applicantFormService.updateAdditionalEvaluationResult(
      reportingPeriodApplicantId,
      additionalEvaluationResult
    );
  }
}
